import { MantineProvider, AppShell } from '@mantine/core';
import { VideoTable } from './components/VideoTable/VideoTable';
import { HeaderMenu } from './components/HeaderMenu/HeaderMenu';
import { TrendingHeader } from './components/TrendingHeader/TrendingHeader';
import { TrendingCards } from './components/TrendingCards/TrendingCards';
import { PrivacyPolicy } from './components/PrivacyPolicy/PrivacyPolicy';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@mantine/core/styles.css';

export function App() {
    return (
        <BrowserRouter>
            <MantineProvider theme={{
                colors: {
                    youtube: ['#FF0000', '#282828', '#0F0F0F', '#FFFFFF', '#CC0000', '#000000', '#123456', '#654321', '#ABCDEF', '#FEDCBA']
                },
                primaryColor: 'youtube'
            }}>
                <AppShell
                    header={{ height: 60 }}
                    padding={0}
                >
                    <AppShell.Header bg="white" withBorder>
                        <HeaderMenu />
                    </AppShell.Header>

                    <AppShell.Main bg="white">
                        <Routes>
                            <Route path="/privacy" element={<PrivacyPolicy />} />
                            <Route path="/" element={
                                <div style={{ padding: '24px 48px' }}>
                                    <TrendingHeader />
                                    <TrendingCards />
                                    <div style={{ height: '32px' }} />
                                    <VideoTable />
                                </div>
                            } />
                        </Routes>
                    </AppShell.Main>
                </AppShell>
            </MantineProvider>
        </BrowserRouter>
    );
}